<template>
  <v-row align-content="center" justify="start">
    <v-dialog
      v-model="dialog"
      persistent
      width="1024"
      @click:outside="dialog = false"
    >
      <template #activator="{ props }">
        <v-btn
          color="green"
          size="x-small"
          variant="plain"
          append-icon="mdi-plus"
          v-bind="props"
          >Adicionar Novo Fluxo</v-btn
        >
      </template>

      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between">
            <span class="text-h5">Adicionar Fluxo</span>
            <v-btn
              variant="plain"
              rounded="xl"
              prepend-icon="mdi-window-close"
              @click="dialog = false"
            ></v-btn>
          </div>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" validate-on="lazy submit">
              <v-row v-if="this.carregado">
                <v-col cols="12" sm="6" md="6">
                  <v-textarea
                    v-model="descricao"
                    required
                    label="Descrição*"
                    placeholder="Passos do fluxo"
                    :rules="descricaoRules"
                  ></v-textarea>
                </v-col>

                <v-col v-if="temPrincipal" cols="12" sm="6">
                  <v-select
                    v-model="tipoFluxo"
                    label="Tipo Fluxo*"
                    :items="tipoFluxos1"
                    :rules="tipoFluxoRules"
                  ></v-select>
                </v-col>

                <v-col v-else cols="12" sm="6">
                  <v-select
                    v-model="tipoFluxo"
                    label="Tipo Fluxo*"
                    :items="tipoFluxos2"
                    :rules="tipoFluxoRules"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row v-else>
                <span>Carregando</span>
                <v-progress-circular class="ml-2" indeterminate size="20" />
              </v-row>
            </v-form>
          </v-container>
          <small>*Campo obrigatório</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue-darken-1" variant="text" @click="submitForm">
            Salvar
            <v-progress-circular
              v-if="this.isLoading"
              class="ml-2"
              indeterminate
              size="20"
            />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
/**
 * @module CreateFluxo
 * @desc Modal com formulário para a criação de um fluxo para o caso de uso.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o modal está visível.
 * @vue-data {string} [descricao=''] - Descrição do fluxo.
 * @vue-data {string} [tipoFluxo=''] - Tipo do fluxo: principal, alternativo ou
 * exceção.
 * @vue-data {boolean} temPrincipal - Flag que indica se o caso de uso em
 * questão já possui um fluxo principal.
 * @vue-data {Array.<String>} tipoFluxos1 - Array com alguns tipos de fluxo.
 * @vue-data {Array.<String>} tipoFluxos2 - Array com um tipo de fluxo,
 * o principal.
 * @vue-data {boolean} [isLoading=false] - Flag que indica se o fluxo ainda
 * está sendo criado.
 */
import axios from 'axios';

import store from '@/store/store';

export default {
  props: {
    id: Number,
  },
  emits: ['fluxoAdicionado'],
  data: () => ({
    dialog: false,
    descricao: '',
    tipoFluxo: '',
    temPrincipal: null,
    tipoFluxos1: ['ALTERNATIVO', 'EXCECAO'],
    tipoFluxos2: ['PRINCIPAL'],
    isLoading: false,
    carregado: false,
    descricaoRules: [(v) => !!v || 'Descrição é obrigatória'],
    tipoFluxoRules: [(v) => !!v || 'Tipo do fluxo é obrigatório'],
  }),
  mounted() {
    this.fetchFluxos(this.id).then((temPrincipal) => {
      this.temPrincipal = temPrincipal;
      this.carregado = true;
    });
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Realiza uma requisição HTTP para obter os fluxos
     * do caso de uso.
     *
     * @param {Number} id O id do caso de uso.
     */
    async fetchFluxos(id) {
      const apiUrl = process.env.VUE_APP_API_URL;
      const response = await axios.get(
        `${apiUrl}/api/v1/fluxoCasoUso/csu/${id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        },
      );
      const fluxos = response.data.fluxos;
      const temPrincipal = fluxos.some(
        (fluxo) => fluxo.tipo_fluxo === 'PRINCIPAL',
      );

      return temPrincipal;
    },

    /**
     * Realiza uma requisição HTTP para criar um novo fluxo
     * para o caso de uso.
     */
    async submitForm() {
      const isValid = (await this.$refs.form.validate()).valid;

      if (isValid) {
        const data = {
          descricao: this.descricao,
          // eslint-disable-next-line camelcase
          tipo_fluxo: this.tipoFluxo,
          // eslint-disable-next-line camelcase
          id_caso_de_uso: Number(this.id),
        };
        try {
          this.isLoading = true;
          const apiUrl = process.env.VUE_APP_API_URL;
          const response = await axios.post(
            `${apiUrl}/api/v1/fluxoCasoUso/`,
            data,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          );

          const idProjeto = this.$route.params.idProjeto;

          this.$toast.success(response.data.msg);
          this.$emit('fluxoAdicionado', this.id);
          this.$router.push(`/projects/${idProjeto}/CasoUso/${this.id}`);
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.msg);
        } finally {
          this.isLoading = false;
          this.dialog = false;
        }
      }
    },
  },
};
</script>
